<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [stroke]="chartOptions.stroke!"
        [colors]="chartOptions.colors!"
        [dataLabels]="chartOptions.dataLabels!"
        [tooltip]="chartOptions.tooltip!"
        [plotOptions]="chartOptions.plotOptions!"
        [markers]="chartOptions.markers!"
        [yaxis]="chartOptions.yaxis!"
        [fill]="chartOptions.fill!"
        [title]="chartOptions.title!"
    ></apx-chart>
</div>